import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { beGetSalonTaxesAndFees } from 'actions/salon/beGetSalonTaxesAndFees.action';
import { usePrepareReadOnly } from 'hooks/usePrepare.hook';
import { useGilt } from 'providers/GILT.provider';

import { setCheckoutSalonTaxesAndFees } from 'checkout/actions';

const CheckoutSalonTaxesAndFeesSync = ({ children }) => {
  const dispatch = useDispatch();
  const { json, isSuccess } = usePrepareReadOnly(beGetSalonTaxesAndFees);

  const taxes = useMemo(() => json?.taxes ?? [], [json]);
  const fees = useMemo(() => json?.fees ?? [], [json]);

  useEffect(() => {
    dispatch(
      setCheckoutSalonTaxesAndFees({
        taxes,
        fees,
      }),
    );
  }, [taxes, fees, dispatch, isSuccess]);

  return children({ taxes, fees });
};

export const CheckoutShell = ({ children }) => {
  const { isSalonInUS } = useGilt();

  if (!isSalonInUS) return children([], []);

  return <CheckoutSalonTaxesAndFeesSync>{(taxes, fees) => children(taxes, fees)}</CheckoutSalonTaxesAndFeesSync>;
};
